import React from 'react'

import './_headline.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import alertCircleIcon from '../../assets/icons/alert-circle.svg'

import Icon from '../icon'

type Props<T extends React.ElementType> = Overwrite<
  CommonProps<T>,
  {
    as?: T
    label: React.ReactNode
    addendum?: React.ReactNode
    icon?: React.ComponentProps<typeof Icon>['source']
    size?: 'default' | 's' | 'l' | 'xl'
    warning?: boolean
    minor?: boolean
    invert?: boolean
    inline?: boolean
  }
>

const Headline = <T extends React.ElementType = 'h1'>({
  className,
  as,
  label,
  addendum,
  icon,
  size = 'default',
  warning = false,
  minor = false,
  invert = false,
  inline = false,
  ...props
}: Props<T>) => {
  const Root = (as ?? 'h1') as React.ElementType
  const finalIcon = warning ? alertCircleIcon : icon

  return (
    <Root
      type={Root === 'button' ? 'button' : undefined}
      {...props}
      className={cn(
        'Headline',
        {warning, minor, invert, inline, [size]: true, addendum: !!addendum},
        className
      )}
    >
      {finalIcon && <Icon key="icon" source={finalIcon} />}
      <div className="Headline__label">{label}</div>
      {addendum && <div className="Headline__addendum">{addendum}</div>}
    </Root>
  )
}

export default Headline
